import { engApi } from "./engApi";

export const getCompany = async () => {
  const response = await engApi.get("/company/");

  return response.data;
};
export const getAllStudent = async () => {
  const response = await engApi.get("/all-student/");

  return response.data;
};
export const getJdInternData = async () => {
  const response = await engApi.get("/jd-intern-data/");

  return response.data;
};

export const getInternStudent = async () => {
  const response = await engApi.get("/intern-student/");

  return response.data;
};

export const getFormAnswer = async () => {
  const response = await engApi.get("/form-answer/");

  return response.data;
};

export const getEvent = async () => {
  const response = await engApi.get("/pretraining/");

  return response.data;
};
export const getActivityLog = async () => {
  const response = await engApi.get("/activity-log/");

  return response.data;
};

export const getActivityLogById = async (stId) => {
  const response = await engApi.get(`/activity-log-by-id?st_id=${stId}`);

  return response.data;
};

export const getEventById = async (event_id) => {
  const response = await engApi.get(`/event-by-id?event_id=${event_id}`);

  return response.data;
};

export const getScoreTrainingLog = async () => {
  const response = await engApi.get("/score-training-log/");

  return response.data;
};

export const getFullTraingLog = async () => {
  const resActivity = await engApi.get("/activity-log/");
  const resPretraining = await engApi.get("/pretraining/");

  const mapData = resActivity.data
    .filter((data) => data.type === "เข้า")
    .map((el) => {
      return {
        ...el,
        eventData: resPretraining.data.find((item) => item.id == el.event_id),
      };
    });

  return mapData;
};

export const getInternshipRequest = async () => {
  const response = await engApi.get("/get-internship-request/");

  return response.data;
};
export const getDocumentRequest = async () => {
  const response = await engApi.get("/document-request/");

  return response.data;
};

export const getDocumentReqStudent = async () => {
  const response = await engApi.get("/document-req-student/");

  return response.data;
};

export const postEvent = async ({
  event_id,
  event_title,
  event_date,
  event_time,
  expert,
  place,
  Year,
}) => {
  const response = await engApi.post(
    `/event?event_id=${event_id}&event_title=${event_title}&event_date=${event_date}&event_time=${event_time}&expert=${expert}&place=${place}&Year=${Year}`
  );

  return response.data;
};

export const postInternManual = async ({
  internRequestId,
  manualData,
  year,
}) => {
  const response = await engApi.post(
    `/intern-manual?intern_request_id=${internRequestId}&manual_data=${manualData}&year=${year}`
  );

  return response.data;
};
export const putInternManual = async ({ internRequestId, manualData }) => {
  const response = await engApi.put(
    `/intern-manual?intern_request_id=${internRequestId}&manual_data=${manualData}`
  );

  return response.data;
};

export const getInternManualById = async (internRequestId) => {
  // https://eng.buu.ac.th/internship/intern-api/intern-manual?intern_request_id=6205047201

  const response = await engApi.get(
    `/intern-manual?intern_request_id=${internRequestId}`
  );
 
  return response.data;
};

export const getInternshipRequestById = async (internRequestId) => {
  const response = await engApi.get(
    `/get-internship-request-by-Id?intern_request_id=${internRequestId}`
    );

  return response.data;
  };




export const getAllManual = async () => {
  const response = await engApi.get("/intern-manual");

  return response.data;
};
export const getInternshipReject = async () => {
  const response = await engApi.get("/internship-reject/");

  return response.data ?? [];
};

export const getJoinDataByCompany = async () => {
  const internStudent = await getInternStudent();
  const allCompany = await getCompany();
  const internshipRequest = await getInternshipRequest();

  const studentDetail = internStudent.map((st) => {
    const find = internshipRequest.find((el) => el.st_id == st.id);

    return {
      ...st,
      internDetail: find,
    };
  });

  const companyWithStd = allCompany.map((company) => {
    const internSt = studentDetail.filter(
      (st) => st.internDetail?.cp_id == company.id
    );

    return {
      ...company,
      internStudent: internSt,
    };
  });

  return companyWithStd;
};

export const getInternRequestWithFullData = async () => {
  const internshipRequest = await getInternshipRequest();
  const internStudent = await getInternStudent();
  const allCompany = await getCompany();
  const internManual = await getAllManual();

  const internshipReqStd = await internshipRequest.map((intern) => {
    const internStd = internStudent.find((st) => st.id == intern.st_id);
    const comp = allCompany.find((company) => company.id == intern?.cp_id);
    const internMnl = internManual.find(
      (int) => int.intern_request_id == intern.req_id
    );

    return {
      ...intern,
      internStudent: internStd,
      company: comp,
      internLocation: internMnl,
    };
  });

  return internshipReqStd;
};
